export default __webpack_public_path__ + "9f5ceeead73405929aabbe2870f5a1cc.png";